import type { IModalBarProps } from "@bonusx-global/bx-design-system";
import { ModalBar } from "@bonusx-global/bx-design-system";
import { TimesSolid } from "@bonusx-global/bx-icons";
import { useCallback } from "react";
import { PREVIOUS_URL_PATH } from "../../../../../../constants/env";
import { useBackNavigation } from "../../../../../../hooks/layout/use-back-navigation/useBackNavigation";
import { useSubscriptionCartStore } from "../../../../../hooks/use-subscription-cart-store/use-subscription-cart-store";

const BACK_NAVIGATION_CONFIG = { url: PREVIOUS_URL_PATH };

export function PhoneNumberConfirmationHeader(props: Readonly<IModalBarProps>): JSX.Element {
  const { performBackNavigation } = useBackNavigation(BACK_NAVIGATION_CONFIG);
  const { resetSubscriptionCart } = useSubscriptionCartStore();

  const onClickToCloseCallback = useCallback(
    function onClickToClose() {
      resetSubscriptionCart();
      performBackNavigation();
    },
    [performBackNavigation, resetSubscriptionCart]
  );

  return <ModalBar {...props} endIcon={<TimesSolid />} onEndIconClick={onClickToCloseCallback} />;
}
